import { Box, Typography } from '@mui/material'
import {
  MOBILE_MQ,
  mobileBodyTextSx,
  mobilePaddingX,
  mobileSectionPy,
  mobileSectionTitleSx,
} from '../../theme/mobileLayout'

export default function StoriesPageHero() {
  return (
    <Box
      component="section"
      sx={{
        width: '100%',
        maxWidth: 1920,
        mx: 'auto',
        px: mobilePaddingX,
        pt: { ...mobileSectionPy, md: '120px', lg: '260px' },
        pb: { xs: 4, md: 6, lg: 0 },
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          maxWidth: 1000,
          mx: 'auto',
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
          alignItems: 'center',
          textAlign: 'center',
          [MOBILE_MQ]: { gap: '16px' },
        }}
      >
        <Typography
          component="h1"
          sx={{
            ...mobileSectionTitleSx,
            fontSize: { ...mobileSectionTitleSx.fontSize, lg: 80 },
            width: '100%',
          }}
        >
          Latest Stories
        </Typography>
        <Typography
          sx={{
            ...mobileBodyTextSx,
            width: '100%',
          }}
        >
          Stay updated with our latest initiatives, community programs, and success stories
        </Typography>
      </Box>
    </Box>
  )
}
